import { Suspense, lazy, useContext, useEffect } from 'react';
import ProtectedRoute from './components/ProtectedRoute.jsx'
import { UserProvider, UserContext } from './context/UserContext.js'
import { Route, Routes, useNavigate } from "react-router-dom";
import AuthService from './services/authService.js';

// Lazy load pages for better performance and code splitting
const Login = lazy(() => import('./pages/login.jsx'));
const Home = lazy(() => import('./pages/home.jsx'));
const ProductDetail = lazy(() => import('./pages/ProductDetail.jsx'));
const AddProduct = lazy(() => import('./pages/AddProduct.jsx'));
const LogoutPage = lazy(() => import('./pages/Logout.jsx'));

// Enhanced loading component with skeleton
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50 dark:from-gray-900 dark:to-gray-800">
    <div className="text-center">
      <div className="animate-pulse">
        <div className="w-16 h-16 bg-blue-200 dark:bg-blue-800 rounded-full mx-auto mb-4"></div>
        <div className="h-4 bg-blue-200 dark:bg-blue-800 rounded w-32 mx-auto mb-2"></div>
        <div className="h-3 bg-blue-100 dark:bg-blue-700 rounded w-24 mx-auto"></div>
      </div>
      <p className="text-gray-600 dark:text-gray-400 mt-4">Loading page...</p>
    </div>
  </div>
);

function App() {
    return (
        <UserProvider>
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/logout" element={
                        <Suspense fallback={<PageLoader />}>
                            <LogoutPage />
                        </Suspense>
                    } />
                    <Route path="/home" element={
                        <ProtectedRoute>
                            <Suspense fallback={<PageLoader />}>
                                <Home />
                            </Suspense>
                        </ProtectedRoute>
                    } />
                    <Route path="/product/add" element={
                        <ProtectedRoute>
                            <Suspense fallback={<PageLoader />}>
                                <AddProduct />
                            </Suspense>
                        </ProtectedRoute>
                    } />
                    <Route path="/product/:id" element={
                        <ProtectedRoute>
                            <Suspense fallback={<PageLoader />}>
                                <ProductDetail />
                            </Suspense>
                        </ProtectedRoute>
                    } />
                </Routes>
            </Suspense>
        </UserProvider>
    )
}

export default App
